import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import {
  GET_ACTIVE_PATIENTS_KEY,
  GET_ALL_ARCHIVED_PATIENTS_KEY,
  GET_ALL_PATIENTS_KEY,
} from '_api/queries/patient';
import { Patient } from '_api/types';

export const ACTIVATE_PATIENT_KEY = 'activate-patient-key';

export const useActivatePatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Patient, { patientId: number }>(
    ({ patientId }) => `/patient/${patientId}/activate`,
    'put',
    {},
    {
      mutationKey: [ACTIVATE_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ACTIVE_PATIENTS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_PATIENTS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ARCHIVED_PATIENTS_KEY] });
      },
    },
  );
};
